var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { zodResolver } from "@hookform/resolvers/zod";
import { Icon, Stepper, TextField, useStepper } from "@opala-ds/react";
import { FormProvider, useFieldArray, useForm, } from "react-hook-form";
import { z } from "zod";
import { useEffect } from "react";
import { useIsMobile } from "../../../../hooks/useIsMobile";
import useCollectiveModalityStore from "../../../../stores/collectiveModalityStore";
import { ImageFileSchema, OptionalStringSchema, RequiredStringSchema, } from "../../../../utils/schemas";
import FileInput from "../../../FileInput";
import FormActions from "../../FormActions";
import TechnicalCPFAndRGField from "./technicalCPFAndRGField";
export function applyMask(value, mask) {
    var formattedValue = "";
    var maskIndex = 0;
    var valueIndex = 0;
    value = (value === null || value === void 0 ? void 0 : value.replace(/\D/g, "")) || "";
    while (maskIndex < mask.length && valueIndex < value.length) {
        if (mask[maskIndex] === "#") {
            if (/\d/.test(value[valueIndex])) {
                formattedValue += value[valueIndex];
                valueIndex++;
            }
            maskIndex++;
        }
        else {
            formattedValue += mask[maskIndex];
            maskIndex++;
        }
    }
    return formattedValue;
}
var comissao_tecnicaSchema = z.object({
    cpf: RequiredStringSchema,
    rg: RequiredStringSchema,
    nome: RequiredStringSchema,
    cref: RequiredStringSchema,
    funcao: OptionalStringSchema,
    foto_arquivo: ImageFileSchema,
});
var Schema = z.object({
    /**
     * A comissão técnica precisa ter pelo menos 1 técnico,
     * mas o usuário pode adicionar quantos forem necessários.
     */
    comissao_tecnica: z.array(comissao_tecnicaSchema).min(1),
});
export default function TechnicalCommitteeTechnicalDataForm(_a) {
    var _this = this;
    var onSubmit = _a.onSubmit, _b = _a.defaultValues, defaultValues = _b === void 0 ? {
        comissao_tecnica: [
            {
                cpf: "",
                rg: "",
                nome: "",
                cref: "",
                funcao: "Técnico",
                foto_arquivo: undefined, // placeholder; FileInput lida com register
            },
        ],
    } : _b;
    /**
     * -------------------------------------------------------------------
     * React‑Hook‑Form setup ---------------------------------------------
     * -------------------------------------------------------------------
     */
    var _c = useForm({
        defaultValues: defaultValues,
        resolver: zodResolver(Schema),
    }), watch = _c.watch, handleSubmit = _c.handleSubmit, register = _c.register, control = _c.control, _d = _c.formState, errors = _d.errors, formStateRest = __rest(_d, ["errors"]), formRest = __rest(_c, ["watch", "handleSubmit", "register", "control", "formState"]);
    var _e = useFieldArray({
        control: control,
        name: "comissao_tecnica",
    }), fields = _e.fields, append = _e.append;
    /**
     * -------------------------------------------------------------------
     * Masks & UI helpers --------------------------------------------------
     * -------------------------------------------------------------------
     */
    var nextStep = useStepper().nextStep;
    var isMobile = useIsMobile();
    var modality = useCollectiveModalityStore(function (state) { return state.modality; });
    /**
     * -------------------------------------------------------------------
     * Handlers ------------------------------------------------------------
     * -------------------------------------------------------------------
     */
    function handleAddTechnician() {
        append({
            cpf: "",
            rg: "",
            nome: "",
            cref: "",
            funcao: "Técnico",
            foto_arquivo: undefined,
        });
    }
    useEffect(function () {
        if (fields.length === 0) {
            append({
                cpf: "",
                rg: "",
                nome: "",
                cref: "",
                funcao: "Técnico",
                foto_arquivo: undefined,
            });
        }
    }, [append, fields.length]);
    /**
     * -------------------------------------------------------------------
     * Render --------------------------------------------------------------
     * -------------------------------------------------------------------
     */
    return (_jsx(FormProvider, __assign({ handleSubmit: handleSubmit, register: register, watch: watch, formState: __assign({ errors: errors }, formStateRest), control: control }, formRest, { children: _jsxs("form", __assign({ className: "w-full flex flex-col space-y-12", onSubmit: handleSubmit(function (data) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, onSubmit(data)];
                        case 1:
                            _a.sent();
                            nextStep();
                            return [2 /*return*/];
                    }
                });
            }); }) }, { children: [_jsxs("div", __assign({ className: "flex flex-col space-y-8 py-8" }, { children: [isMobile && (_jsx("div", __assign({ className: "flex justify-start" }, { children: _jsx(Stepper.Radial, { size: 70, weight: 5 }) }))), _jsx("span", __assign({ className: "text-sm font-semibold text-[#022A59]" }, { children: modality })), fields.map(function (field, index) {
                            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
                            return (_jsxs("div", __assign({ className: "flex flex-col space-y-8" }, { children: [_jsx("span", __assign({ className: "text-sm font-semibold text-[#022A59]" }, { children: "Dados do t\u00E9cnico ".concat(index + 1) })), _jsxs("div", __assign({ className: "grid grid-cols-1 md:grid-cols-2 gap-4" }, { children: [_jsx(TechnicalCPFAndRGField, { errors: errors, index: index, 
                                                // @ts-ignore
                                                register: register }), _jsx(TextField, __assign({ label: "Nome", placeholder: "Digite o nome", size: "md", helperText: 
                                                // @ts-ignore
                                                (_d = (_c = (_b = (_a = errors.comissao_tecnica) === null || _a === void 0 ? void 0 : _a[index]) === null || _b === void 0 ? void 0 : _b.nome) === null || _c === void 0 ? void 0 : _c.message) !== null && _d !== void 0 ? _d : "", variant: 
                                                // @ts-ignore
                                                ((_f = (_e = errors.comissao_tecnica) === null || _e === void 0 ? void 0 : _e[index]) === null || _f === void 0 ? void 0 : _f.nome)
                                                    ? "critical"
                                                    : "default" }, register("comissao_tecnica.".concat(index, ".nome")))), _jsx(TextField, __assign({ label: "CREF", placeholder: "Digite o CREF", size: "md", helperText: 
                                                // @ts-ignore
                                                (_k = (_j = (_h = (_g = errors.comissao_tecnica) === null || _g === void 0 ? void 0 : _g[index]) === null || _h === void 0 ? void 0 : _h.cref) === null || _j === void 0 ? void 0 : _j.message) !== null && _k !== void 0 ? _k : "", variant: 
                                                // @ts-ignore
                                                ((_m = (_l = errors.comissao_tecnica) === null || _l === void 0 ? void 0 : _l[index]) === null || _m === void 0 ? void 0 : _m.cref)
                                                    ? "critical"
                                                    : "default" }, register("comissao_tecnica.".concat(index, ".cref"))))] })), _jsx("span", __assign({ className: "mb-7 text-sm font-semibold text-[#022A59]" }, { children: "Envio da foto do t\u00E9cnico ".concat(index + 1) })), _jsx(FileInput, __assign({ label: "Foto", 
                                        /**
                                         * O FileInput exibe a miniatura da foto se existir um valor
                                         * padrão. No fluxo de edição, "defaultValues" cobre isso,
                                         * no fluxo de criação, não há valor.
                                         */
                                        accept: ".jpg,.png", defaultValue: (_q = (_p = (_o = defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.comissao_tecnica) === null || _o === void 0 ? void 0 : _o[index]) === null || _p === void 0 ? void 0 : _p.foto_arquivo) === null || _q === void 0 ? void 0 : _q[0] }, register("comissao_tecnica.".concat(index, ".foto_arquivo")), { 
                                        // @ts-ignore
                                        error: (_t = (_s = (_r = errors.comissao_tecnica) === null || _r === void 0 ? void 0 : _r[index]) === null || _s === void 0 ? void 0 : _s.foto_arquivo) === null || _t === void 0 ? void 0 : _t.message }))] }), field.id));
                        }), _jsxs("button", __assign({ type: "button", className: "flex justify-center items-center gap-1 self-end font-semibold text-sm text-[#022A59] border-blue-900", onClick: handleAddTechnician }, { children: [_jsx(Icon, { name: "Plus", size: 20 }), "Adicionar outro t\u00E9cnico"] }))] })), _jsx(FormActions, {})] })) })));
}
